import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from '@vds-core/theme';
import { calculateRem } from '@uie/javascript-style-helpers';
import { withVDSManager } from '@vds-core/utilities';
var propTypes = {
  /**
   *  Individual Breadcrumbs, in the order they need to be displayed. The Breadcrumb component is typically used for this implementation
   */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,

  /**
   * @deprecated
   */
  className: PropTypes.string,

  /**
   *  If provided, used as string that labels the element for accessibility.
   */
  ariaLabel: PropTypes.string,

  /**
   *  @ignore
   */
  colorConfig: PropTypes.object,

  /**
   * Allows a string to be provided for analytics.
   */
  'data-analyticstrack': PropTypes.string,

  /**
   * Allows a string to be provided for analytics.
   */
  'data-track': PropTypes.string,

  /**
   * Allows a string to be provided for click stream.
   */
  'data-clickstream': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-level': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-position': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-datatrack': PropTypes.string,

  /**
   * Allows a string to be provided for analytics tagging.
   */
  'data-sitecat-cta': PropTypes.string,

  /**
   * Allows a unique ID to be passed to the component.
   */
  id: PropTypes.string,

  /**
   * @ignore
   *
   */
  inverted: PropTypes.bool
};
var defaultProps = {
  className: null,
  colorConfig: colors,
  inverted: false,
  ariaLabel: 'Breadcrumb'
};
var StyledNav = /*#__PURE__*/styled.nav.withConfig({
  displayName: "StyledNav",
  componentId: "sc-k5phk0-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n  font-weight: 400;\n  font-style: normal;\n  color: ", ";\n  line-height: 1.25;\n"])), colors.black);
var StyledBreadcrumbList = /*#__PURE__*/styled.ol.withConfig({
  displayName: "StyledBreadcrumbList",
  componentId: "sc-k5phk0-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  padding-left: 0;\n  list-style-type: decimal;\n  margin: 0;\n"])));
export var Breadcrumbs = /*#__PURE__*/function (_Component) {
  _inherits(Breadcrumbs, _Component);

  var _super = _createSuper(Breadcrumbs);

  function Breadcrumbs(props) {
    var _this;

    _classCallCheck(this, Breadcrumbs);

    _this = _super.call(this, props);
    _this.state = {};
    return _this;
  } // Render Breadcrumb List children


  _createClass(Breadcrumbs, [{
    key: "renderBreadcrumbs",
    value: function renderBreadcrumbs() {
      var _this$props = this.props,
          children = _this$props.children,
          inverted = _this$props.inverted;
      var childCount = React.Children.count(children);
      var _this$props2 = this.props,
          analyticsTrack = _this$props2['data-analyticstrack'],
          track = _this$props2['data-track'],
          clickStream = _this$props2['data-clickstream'],
          cta = _this$props2['data-sitecat-cta'],
          dataTrack = _this$props2['data-sitecat-datatrack'],
          position = _this$props2['data-sitecat-position'],
          level = _this$props2['data-sitecat-level'];
      return React.Children.map(children, function (child, index) {
        if (index === 0) {
          return /*#__PURE__*/React.cloneElement(child, {
            inverted: inverted,
            firstChild: true,
            'data-analyticstrack': analyticsTrack,
            'data-track': track,
            'data-clickstream': clickStream,
            'data-sitecat-cta': cta,
            'data-sitecat-datatrack': dataTrack,
            'data-sitecat-position': position,
            'data-sitecat-level': level
          });
        } else if (index === childCount - 1) {
          return /*#__PURE__*/React.cloneElement(child, {
            inverted: inverted,
            active: child.props.active === false ? child.props.active : true,
            lastChild: true,
            'data-analyticstrack': analyticsTrack,
            'data-track': track,
            'data-clickstream': clickStream,
            'data-sitecat-cta': cta,
            'data-sitecat-datatrack': dataTrack,
            'data-sitecat-position': position,
            'data-sitecat-level': level
          });
        } else {
          return /*#__PURE__*/React.cloneElement(child, {
            inverted: inverted,
            'data-analyticstrack': analyticsTrack,
            'data-track': track,
            'data-clickstream': clickStream,
            'data-sitecat-cta': cta,
            'data-sitecat-datatrack': dataTrack,
            'data-sitecat-position': position,
            'data-sitecat-level': level
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          analyticsTrack = _this$props3['data-analyticstrack'],
          track = _this$props3['data-track'],
          clickStream = _this$props3['data-clickstream'];
      return /*#__PURE__*/React.createElement(StyledNav, {
        id: this.props.id,
        className: this.props.className,
        colors: this.props.colorConfig,
        "data-analyticstrack": analyticsTrack,
        "data-track": track,
        "data-clickstream": clickStream,
        "aria-label": this.props.ariaLabel
      }, /*#__PURE__*/React.createElement(StyledBreadcrumbList, null, this.renderBreadcrumbs()));
    }
  }]);

  return Breadcrumbs;
}(Component);
Breadcrumbs.propTypes = propTypes;
Breadcrumbs.defaultProps = defaultProps;
export default withVDSManager(Breadcrumbs);